import {MouseEventHandler} from 'react';
import { FormattedMessage } from 'react-intl';
import { LoadingButton, LoadingButtonProps } from '@mui/lab';

export type SaveButtonProps = LoadingButtonProps & {
  labelId?: string;
  onClick?: MouseEventHandler;
};

const SaveButton = ({labelId = 'button.save', ...props} : SaveButtonProps) : JSX.Element => {
  return (
    <LoadingButton variant='contained' {...props}>
      <FormattedMessage id={labelId} />
    </LoadingButton>
  );
};

export default SaveButton;